import { FoodTypesDto } from "@gtpl/shared-models/masters";
import { ValueAdditionFourType } from "../value-addition-four.entity";
import { ValueAdditionFourDTO } from "./value-addition-four.dto";

export class ValueAddFourTypeAdapter {
    convertDtoToEntity(dtoObj: ValueAdditionFourDTO,  isUpdate: boolean = false ): ValueAdditionFourType {
        try {
            const entityObj = new ValueAdditionFourType();
            entityObj.valueAdditionFourId = dtoObj.valueAdditionFourId
            entityObj.code = dtoObj.code;
            entityObj.name = dtoObj.name;
            entityObj.remarks = dtoObj.remarks;
            entityObj.isActive=dtoObj.isActive==undefined?true:dtoObj.isActive;
            if (isUpdate){
                entityObj.updatedUser = dtoObj.updatedUser;
            }else {
                entityObj.isActive = true;
                entityObj.createdUser=dtoObj.createdUser;
            }
            return entityObj;
        } catch (Error) {
            throw Error;
        }
    }

    public convertEntityToDto(employeeObject: ValueAdditionFourType): ValueAdditionFourDTO {
        const foodTypeDetailsDTO= new ValueAdditionFourDTO;
        foodTypeDetailsDTO.valueAdditionFourId = employeeObject.valueAdditionFourId;
        foodTypeDetailsDTO.code = employeeObject.code;
        foodTypeDetailsDTO.name = employeeObject.name;
        foodTypeDetailsDTO.remarks = employeeObject.remarks;
        foodTypeDetailsDTO.isActive = employeeObject.isActive;
        foodTypeDetailsDTO.createdAt = employeeObject.createdAt;
        foodTypeDetailsDTO.updatedAt = employeeObject.updatedAt;
        foodTypeDetailsDTO.createdUser = employeeObject.createdUser;
        foodTypeDetailsDTO.updatedUser = employeeObject.updatedUser;
        foodTypeDetailsDTO.versionFlag = employeeObject.versionFlag;
        return foodTypeDetailsDTO;
      }
}